import React from 'react';
import { Helmet } from 'react-helmet';
import { withTheme, Theme } from 'styled-components';
import { locales } from '@whitelabel/helpers/site';

interface IPageMetaProps {
  title?: string;
  seoTitle?: string;
  searchDescription?: string;
  socialTitle?: string;
  socialDescription?: string;
  socialImage?: string;
  ogType?: string;
  locale?: string;
  location: any; // TODO: ReactRouterPropTypes.location
  isTranslated?: boolean;
  theme: Theme;
  script?: {
    src: string;
    type?: string;
  }[];
  protocolDomain: string;
  siteName: string;
}

const handleLocalization = (locale: string, protocolDomain: string): JSX.Element[] =>
  Object.values(locales).map(({ code }: any) => (
    <link
      key={code}
      rel="alternate"
      href={`${protocolDomain}${location.pathname.replace(`/${locale}`, `/${code}`)}`}
      hrefLang={code}
    />
  ));

const PageMeta = ({
  title,
  seoTitle,
  searchDescription,
  socialTitle,
  socialDescription,
  socialImage,
  ogType,
  locale = 'en',
  location,
  isTranslated = true,
  theme,
  script,
  siteName,
  protocolDomain,
}: IPageMetaProps) => (
  <Helmet defaultTitle={siteName} titleTemplate={`%s | ${siteName}`}>
    <html lang={locale} dir={locale === 'ar' ? 'rtl' : 'ltr'} />

    {(seoTitle || title) && <title>{seoTitle || title}</title>}
    {searchDescription && <meta name="description" content={searchDescription} />}

    <link rel="mask-icon" href="/static/safari-pinned-tab.svg" color={theme.themeColors.primary} />
    <meta name="theme-color" content={theme.themeColors.primary} />

    <meta property="og:url" content={`${protocolDomain}${location.pathname}`} />
    {(socialTitle || seoTitle || title) && <meta property="og:title" content={socialTitle || seoTitle || title} />}
    {(socialDescription || searchDescription) && (
      <meta property="og:description" content={socialDescription || searchDescription} />
    )}
    {socialImage && <meta property="og:image" content={socialImage} />}
    {ogType && <meta property="og:type" content={ogType} />}
    <link rel="canonical" href={`${protocolDomain}${location.pathname}`} />
    {isTranslated && handleLocalization(locale, protocolDomain)}
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'http://schema.org',
        '@type': 'Organization',
        url: protocolDomain,
        name: siteName,
      })}
    </script>
    {script && script.map((props: any) => <script key={props.src} {...props} />)}
  </Helmet>
);

export default withTheme(PageMeta);
